import { AHText, AHTextFonts, Box } from "arkh";
import { FormattedMessage } from "react-intl";
import React, { useMemo } from "react";

import { graphql, useFragment } from "react-relay";
import { IntegrationAdminListItem } from "./components/IntegrationAdminListItem";

import { useNavigation } from "@react-navigation/native";
import { StoreAdminNavigationProp } from "../StoreAdmin/StoreAdminNavigation";
import { IntegrationAdminPollFileListItem_IntegrationPollFile$key } from "./__generated__/IntegrationAdminPollFileListItem_IntegrationPollFile.graphql";

export function IntegrationAdminPollFileListItem(props: {
  isFirst: boolean;
  isLast: boolean;
  pollFile: IntegrationAdminPollFileListItem_IntegrationPollFile$key;
}) {
  const navigation =
    useNavigation<StoreAdminNavigationProp<"IntegrationAdmin">>();

  const pollFile = useFragment(
    graphql`
      fragment IntegrationAdminPollFileListItem_IntegrationPollFile on IntegrationPollFile {
        id
        url
        file {
          name
        }
      }
    `,
    props.pollFile
  );

  const host = useMemo(() => {
    try {
      return new URL(pollFile.url).host;
    } catch {}
  }, [pollFile.url]);

  return (
    <IntegrationAdminListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      active={!!pollFile.file}
      pending={!pollFile.file}
      onPress={() =>
        navigation.navigateDeprecated("IntegrationFlyer", {
          id: pollFile.id,
          title: pollFile.file?.name ?? "",
          lastCheckedAt: null,
          lastError: null,
          status: pollFile.file ? "success" : "pending",
          type: "pollFile",
        })
      }
    >
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <AHText type="title-small" font={AHTextFonts.REGULAR} numberOfLines={1}>
          <FormattedMessage
            description="IntegrationsAdminPollFileListItem title"
            defaultMessage="Online Leaflet"
          />
        </AHText>
        <AHText spaceLeft="small" numberOfLines={1}>
          {host}
        </AHText>
      </Box>
    </IntegrationAdminListItem>
  );
}
